module.exports = __webpack_public_path__ + "static/media/trivia-round3.60ad4e9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/trivia-round3.png
// module id = 2680
// module chunks = 0